import { render } from "./MainButton.vue?vue&type=template&id=55d46700&scoped=true"
import script from "./MainButton.vue?vue&type=script&lang=js"
export * from "./MainButton.vue?vue&type=script&lang=js"

import "./MainButton.vue?vue&type=style&index=0&id=55d46700&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d46700"]])

export default __exports__